import go from 'gojs';
import base64 from 'react-native-base64';
import { apiGet, apiPost, getHostApi } from '../../apiWrapper';
import { isNullOrUndefined, updateObject } from '../../storeFunctions';
import { _updateBottomWindow } from '../bottomWindow/actions';
import { GRAPH_TYPE, LOAD_TYPE, _name } from '../common/constants';
import { _handleError } from '../common/functions';
import { _fitDiagram, _load, _processParams, _updateTotalNodeCount, diagramActions } from '../diagram/actions';
import { diagram } from '../diagram/initial';
import { _resetExportButtons } from '../exports/actions';
import { leftPanelActions } from '../leftPanel/actions';
import { tooltipsActions } from '../tooltips/actions';
import { _createCookieString, _getGraphType, _useProfile } from '../topPanel/actions';
import { visualizationInitial } from './initial';

// KEYS
const actions = {
    VISUALIZATION_UPDATE: _name + '_VISUALIZATION_UPDATE'
};

// MAP
const actionMap = {
    [`${actions.VISUALIZATION_UPDATE}`]: (state, data) => updateObject(state, { visualizations: updateObject(state.visualizations, data) }),
}

// ACTIONS
const chartActions = {
    saveVisualizationAs: (data, onSuccess) => async (dispatch, getState) => {
        const reqParams = _createSaveVisualizationReqParams(getState, data);
        apiPost(`${getHostApi()}/api/charts/add-visualization`, undefined, reqParams,
            res => {
                if (res.data && onSuccess) {
                    onSuccess(res.data);
                }
            },
            e => _handleError('/api/charts/add-visualization error', e, getState),
        );
    },
    saveVisualization: () => async (dispatch, getState) => {
        const state = getState().charts;
        if (isNullOrUndefined(state.visualizations.loadedVisualization) || isNullOrUndefined(state.visualizations.data))
            return;
        const visualization = state.visualizations.data.find(x => x.visualizationId === state.visualizations.loadedVisualization.id);
        if (visualization != null) {
            const reqParams = _createSaveVisualizationReqParams(getState, visualization);
            dispatch({ type: actions.VISUALIZATION_UPDATE, data: { saving: true } });
            apiPost(`${getHostApi()}/api/charts/update-visualization`, undefined, { ...reqParams, visualizationId: visualization.visualizationId },
                _ => { },
                e => _handleError('/api/charts/update-visualization error', e, getState),
                _ => dispatch({ type: actions.VISUALIZATION_UPDATE, data: { saving: false } })
            );
        }
    },
    getVisualizations: (page) => async (dispatch, getState) => {
        _getVisualizations(dispatch, getState, page);
    },
    refreshVisualizations: () => async (dispatch, getState) => {
        const state = getState().charts;
        _getVisualizations(dispatch, getState, state.visualizations.selectedPage);
    },
    loadVisualization: (visualizationId) => async (dispatch, getState) => {
        _loadVisualization(dispatch, getState, visualizationId);
    },
    renameVisualization: (visualizationId, title, onSuccess) => async (dispatch, getState) => {
        if (!isNullOrUndefined(title) && title.trim() !== "") {
            const requestData = ({ visualizationId: visualizationId, title: title.trim() });
            apiPost(`${getHostApi()}/api/charts/rename-visualization`, undefined, requestData,
                _ => {
                    onSuccess();
                },
                e => _handleError('/api/charts/update-visualization error', e, getState),
            );
        }
    },
    deleteVisualization: (visualizationId) => async (dispatch, getState) => {
        apiGet(`${getHostApi()}/api/charts/delete-visualization`, { visualizationId: visualizationId },
            res => {
                if (res != null && res.data === true) {
                    const state = getState().charts;
                    if (state.visualizations.loadedVisualization !== undefined && state.visualizations.loadedVisualization.id === visualizationId)
                        dispatch({ type: actions.VISUALIZATION_UPDATE, data: { loadedVisualization: undefined } });

                    _getVisualizations(dispatch, getState, state.visualizations.selectedPage);
                }
            },
            e => _handleError('/api/charts/delete-visualization error', e, getState),
        );
    },
    reloadVisualization: () => async (dispatch, getState) => {
        _load(dispatch, getState, LOAD_TYPE.reload);
    }
}

//FUNCTIONS
function _resetVisualizations(dispatch) {
    dispatch({ type: actions.VISUALIZATION_UPDATE, data: { ...visualizationInitial } });
}

function _createSaveVisualizationReqParams(getState, data) {
    const diagramImage = diagram.nodeDiagram.makeImage({
        background: "transparent",
        showTemporary: true,
        size: new go.Size(NaN, 150),
    });
    const nodes = diagram._nodes;
    nodes.forEach(function (value) {
        var n = diagram.nodeDiagram.findNodeForKey(value.EntityID);
        value.Location = go.Point.stringify(n.part.location);
        return value;
    });
    const mode = getState().charts.mode;
    const cookieString = _createCookieString(getState);

    const reqParams = {
        isStatic: data.isStatic || data.type === "static",
        title: data.title,
        thumbnail: base64.encode(diagramImage.src),
        nodeCount: diagram._nodes.length,
        rootIds: diagram._rootIdList,
        stateData: JSON.stringify({
            nodes: nodes,
            relations: diagram._relations,
            relationsOriented: diagram._relationsOriented,
            initParams: diagram._initParams,
            mode: mode
        }),
        profileData: base64.encode(cookieString.join('|'))
    };
    return reqParams;
}

function _getVisualizations(dispatch, getState, page) {
    const pageSize = 10;
    dispatch({ type: actions.VISUALIZATION_UPDATE, data: { loading: true } });
    apiPost(`${getHostApi()}/api/charts/visualizations`, {}, { rootIds: diagram._rootIdList, offset: (page - 1) * pageSize, count: pageSize },
        res => {
            if (!isNullOrUndefined(res.data) && !isNullOrUndefined(res.data.items)) {
                const items = res.data.items;
                items.forEach(x => {
                    if (!isNullOrUndefined(x.thumbnail)) {
                        x.thumbnail = base64.decode(x.thumbnail)
                    }
                });
                dispatch({ type: actions.VISUALIZATION_UPDATE, data: { data: items, selectedPage: page, totalPages: Math.ceil(res.data.total / pageSize) } });
            }
        },
        e => {
            _handleError('/api/charts/visualizations error', e, getState);
        },
        _ => {
            dispatch({ type: actions.VISUALIZATION_UPDATE, data: { loading: false } });
        }
    );
}

function _loadVisualization(dispatch, getState, visualizationId) {
    dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: true } });
    apiGet(`${getHostApi()}/api/charts/visualization`, { visualizationId: visualizationId },
        res => {
            if (res != null && res.data != null) {
                const profileData = res.data.profileData;
                const stateData = JSON.parse(res.data.stateData);
                _processVisualizationData(dispatch, getState, res.data, stateData, base64.decode(profileData));
            }
        }, err => {
            _handleError('/api/charts/visualization error', err, getState);
        },
        _ => {
            dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: false } });
        }
    );
}

function _processVisualizationData(dispatch, getState, data, stateData, cookieString) {
    const { visualizationId, isStatic, rootIds } = data;

    // PROCESS PARAMS
    diagram._rootIdList = rootIds;
    _processParams(dispatch, getState, { ...stateData.initParams, mode: stateData.mode });

    // LOAD
    if (isStatic) {
        diagram.selectedNodes = [];
        dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: true } });
        dispatch({ type: tooltipsActions.CONTEXT_MENU.HIDE });
        _resetExportButtons(dispatch);

        var rtUsed = [];
        var wtUsed = [];

        diagram._relationsOriented = stateData.relationsOriented;
        diagram._relations = stateData.relations;
        diagram._nodes = stateData.nodes;

        const graphType = _getGraphType();

        diagram.nodeDiagram.model.nodeDataArray = diagram._nodes;
        diagram.nodeDiagram.model.nodeDataArray.forEach((node) => {
            node.WarningShortcuts.forEach((w) => {
                if (wtUsed.indexOf(w.GroupID) === -1)
                    wtUsed.push(w.GroupID);
            });
        });
        diagram.nodeDiagram.model.linkDataArray = (graphType === GRAPH_TYPE.oriented ? diagram._relationsOriented : diagram._relations);
        diagram.nodeDiagram.model.linkDataArray.forEach(function (r) {
            r.RelationsData.forEach(function (rd) {
                if (rtUsed.indexOf(rd.TypeCD) === -1)
                    rtUsed.push(rd.TypeCD);
            })
        });
        diagram.nodeDiagram.model.isReadOnly = true;

        _updateTotalNodeCount(dispatch);
        _useProfile(dispatch, getState, cookieString, undefined, true);
        _fitDiagram();
        _updateBottomWindow(dispatch);
        dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { historyChanged: false, filterChanged: false, directionChanged: false, shareChanged: false, relationTypesChanged: false, rtUsed, wtUsed } });
        dispatch({ type: diagramActions.ROOT_UPDATE, data: { loading: false } });
    } else {
        diagram._relationsOriented = stateData.relationsOriented;
        diagram._relations = stateData.relations;
        diagram._nodes = stateData.nodes;

        const graphType = _getGraphType();

        diagram.nodeDiagram.model.nodeDataArray = diagram._nodes;
        diagram.nodeDiagram.model.linkDataArray = (graphType === GRAPH_TYPE.oriented ? diagram._relationsOriented : diagram._relations);

        _useProfile(dispatch, getState, cookieString, undefined, true);
        _load(dispatch, getState, LOAD_TYPE.reload);
    }

    const visualizations = (getState().charts.visualizations.data || []);
    if (visualizations.filter(x => x.visualizationId === visualizationId).length === 0) {
        visualizations.push(data);
    }
    dispatch({ type: actions.VISUALIZATION_UPDATE, data: { data: visualizations, loadedVisualization: { id: visualizationId, isStatic: isStatic } } });
}

export {
    _loadVisualization, _resetVisualizations,
    actionMap as visualizationActionMap, actions as visualizationActions, chartActions as visualizationChartActions
};

